import * as React from "react";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";
import { alpha, styled } from "@mui/material/styles";
import TreeView from "@mui/lab/TreeView";
import TreeItem, { treeItemClasses } from "@mui/lab/TreeItem";
import Collapse from "@mui/material/Collapse";
// web.cjs is required for IE11 support
import { animated, useSpring } from "@react-spring/web";
import { useState } from "react";
import { useEffect } from "react";
import { common_axios } from "../../App";
import { toast } from "react-toastify";
import { Backdrop } from "@mui/material";
import Loader from "../../components/Loader";
import AccountTreeIcon from "@mui/icons-material/AccountTree";

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon
      className="close"
      fontSize="inherit"
      style={{ width: 14, height: 14 }}
      {...props}
    >
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

function TransitionComponent(props) {
  const style = useSpring({
    from: {
      opacity: 0,
      transform: "translate3d(20px,0,0)",
    },
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

TransitionComponent.propTypes = {
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
};

const StyledTreeItem = styled((props) => (
  <TreeItem {...props} TransitionComponent={TransitionComponent} />
))(({ theme }) => ({
  [`& .${treeItemClasses.iconContainer}`]: {
    "& .close": {
      opacity: 0.3,
    },
  },
  [`& .${treeItemClasses.group}`]: {
    marginLeft: 15,
    paddingLeft: 18,
    borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  },
}));

export default function TestTree() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState();
  const [data1, setData1] = useState([]);
  const [level, setLevel] = useState(1);

  const fetchUser = async () => {
    try {
      setOpen(true);
      const res = await common_axios(`admin/v1/user/details/tree?cpId=130`);

      if (res.data.statusDescription.statusCode == 200) {
        setData1(res.data.userDetail.subUserList);

        setOpen(false);
      } else {
        setOpen(false);
        toast.error(res.data.statusDescription.statusMessage, {
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  const fetchUser1 = async () => {
    if (data != undefined) {
      try {
        setOpen(true);
        const res = await common_axios(
          `admin/v1/user/details/tree?cpId=${data.d.uid}`
        );

        if (res.data.statusDescription.statusCode == 200) {
          if (level == 1) {
            const oldData = [...data1];
            oldData[data.index].subUserList = res.data.userDetail.subUserList;
            setData1(oldData);
          }

          if (level == 2) {
            const oldData = [...data1];

            oldData[data.index].subUserList[data.indexx].subUserList =
              res.data.userDetail.subUserList;
            setData1(oldData);
          }

          if (level == 3) {
            const oldData = [...data1];

            oldData[data.index].subUserList[data.indexx].subUserList[
              data.indexxx
            ].subUserList = res.data.userDetail.subUserList;
            setData1(oldData);
          }

          if (level == 4) {
            const oldData = [...data1];

            oldData[data.index].subUserList[data.indexx].subUserList[
              data.indexxx
            ].subUserList[data.indexxxx].subUserList =
              res.data.userDetail.subUserList;
            setData1(oldData);
          }
          setOpen(false);
        } else {
          setOpen(false);
          toast.error(res.data.statusDescription.statusMessage, {
            theme: "colored",
          });
        }
      } catch (error) {
        setOpen(false);
        console.log(error);
        await toast.error("Something went wrong", {
          theme: "colored",
        });
      }
    }
  };
  useEffect(async () => {
    fetchUser();
  }, []);

  useEffect(async () => {
    fetchUser1();
  }, [
    data?.index,
    data?.indexx,
    data?.indexxx,
    data?.indexxxx,
    data?.indexxxxx,
    level,
  ]);

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        // onClick={handleClose}
      >
        <Loader />
      </Backdrop>

      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-12 col-sm-12 mb-xl-0 mb-4">
            <div class="card mb-3 mt-4">
              <div class="card-header p-3 pt-2">
                <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                  <AccountTreeIcon sx={{ color: "white", fontSize: "33px" }} />
                </div>
                <div class="pt-1 marginleft_0">
                  <p class="text-sm mb-0 text-capitalize fw-bold">
                    Profile Details
                  </p>
                </div>
              </div>
              <div class="container">
                <div class="row justify-content-between mb-5">
                  <div class="col-md-4 mt-4 sidebar_1 p-0">
                    <ul
                      class="nav nav-tabs nav-tabs_1 d-block"
                      id="myTab"
                      role="tablist"
                    >
                      <li class="nav-item" role="presentation">
                        <TreeView
                          aria-label="customized"
                          defaultExpanded={["1"]}
                          defaultCollapseIcon={<MinusSquare />}
                          defaultExpandIcon={<PlusSquare />}
                          defaultEndIcon={<CloseSquare />}
                          sx={{
                            height: "auto",
                            flexGrow: 1,
                            // maxWidth: 400,
                            overflowY: "auto",
                          }}
                        >
                          {data1?.map((d, index) => {
                            return (
                              <StyledTreeItem
                                nodeId={`Child ${d.uid}`}
                                label={d.username}
                                key={d.uid}
                                onClick={() => {
                                  setData({ d, index });
                                  setLevel(1);

                                  // fetchUser1(d.uid, index);
                                }}
                              >
                                {data1[index]?.subUserList?.map(
                                  (d1, indexx) => {
                                    return (
                                      <StyledTreeItem
                                        nodeId={`Sub Child ${d1.uid}`}
                                        label={d1.username}
                                        key={d1.uid}
                                        onClick={() => {
                                          setData({ d: d1, index, indexx });
                                          setLevel(2);
                                          // fetchUser1(d1.uid, indexx);
                                        }}
                                      >
                                        {data1[index]?.subUserList[
                                          data.indexx
                                        ]?.subUserList?.map((d2, indexxx) => {
                                          return (
                                            <StyledTreeItem
                                              nodeId={`Sub Sub Child ${d2.uid}`}
                                              label={d2.username}
                                              key={d2.uid}
                                              onClick={() => {
                                                setData({
                                                  d: d2,
                                                  index,
                                                  indexx,
                                                  indexxx,
                                                });
                                                setLevel(3);
                                                // fetchUser1(d1.uid, indexx);
                                              }}
                                            >
                                              {data1[index]?.subUserList[
                                                data.indexx
                                              ]?.subUserList[
                                                data.indexxx
                                              ]?.subUserList?.map(
                                                (d3, indexxxx) => {
                                                  return (
                                                    <StyledTreeItem
                                                      nodeId={`Sub Sub Sub Child ${d3.uid}`}
                                                      label={d3.username}
                                                      key={d3.uid}
                                                      onClick={() => {
                                                        setData({
                                                          d: d3,
                                                          index,
                                                          indexx,
                                                          indexxx,
                                                          indexxxx,
                                                        });
                                                        setLevel(4);
                                                        // fetchUser1(d1.uid, indexx);
                                                      }}
                                                    >
                                                      {data1[
                                                        index
                                                      ]?.subUserList[
                                                        data.indexx
                                                      ]?.subUserList[
                                                        data.indexxx
                                                      ]?.subUserList[
                                                        data.indexxxx
                                                      ]?.subUserList?.map(
                                                        (d4, indexxxxx) => {
                                                          return (
                                                            <StyledTreeItem
                                                              nodeId={`Sub Sub Sub Sub Child ${d4.uid}`}
                                                              label={
                                                                d4.username
                                                              }
                                                              key={d4.uid}
                                                              onClick={() => {
                                                                setData({
                                                                  d: d4,
                                                                  index,
                                                                  indexx,
                                                                  indexxx,
                                                                  indexxxx,
                                                                  indexxxxx,
                                                                });
                                                                setLevel(5);
                                                                // fetchUser1(d1.uid, indexx);
                                                              }}
                                                            ></StyledTreeItem>
                                                          );
                                                        }
                                                      )}
                                                    </StyledTreeItem>
                                                  );
                                                }
                                              )}
                                            </StyledTreeItem>
                                          );
                                        })}
                                      </StyledTreeItem>
                                    );
                                  }
                                )}
                              </StyledTreeItem>
                            );
                          })}
                        </TreeView>
                      </li>
                    </ul>
                  </div>
                  {data != undefined && (
                    <div class="col-md-7">
                      <div class="tab-content" id="myTabContent">
                        <div
                          class="tab-pane fade show active"
                          id="home"
                          role="tabpanel"
                          aria-labelledby="home-tab"
                        >
                          <div class="table-responsive pb-5 mt-4">
                            <table class="table table_8 table-sm table-bordered table-striped m-auto">
                              <thead>
                                <tr class="table-primary text-center fw-bold">
                                  <td colSpan="2" class="details">
                                    Profile Details
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th>User Name</th>
                                  <td>
                                    <p className="fw-bold m-0">
                                      {data?.d?.username}
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <th>Contact Number</th>
                                  <td>
                                    <p className="fw-bold m-0">
                                      {data?.d?.mobile}
                                    </p>
                                  </td>
                                </tr>

                                <tr>
                                  <th>Role</th>
                                  <td>
                                    <p className="fw-bold m-0">
                                      {data?.d?.roleName}
                                    </p>
                                  </td>
                                </tr>

                                <tr>
                                  <th>Service List</th>
                                  <td className="d-flex flex-wrap">
                                    <a className="btn btn-primary details m-0 m-1">
                                      Tags
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
